// src/client/navigation/AppNavigator.tsx
// Layout component nested inside ProtectedRoute + KycGuard. Each tab screen
// renders its own NavBar; flow screens (apply, confirm, success) do not.
import { Outlet } from 'react-router-dom';

export default function AppNavigator() {
  return <Outlet />;
}
